/* Capybara - En profondeur (cp-story-tabs). Onglets sur ordinateur, accordeon sous 64rem.
   Sorti du fichier de section le 03/09/2026 (taille) ; un seul etat actif pilote les deux rendus. */
(function () {
  function init(root) {
    if (root.dataset.cptInit) return;
    root.dataset.cptInit = '1';

    root.querySelectorAll('[data-cpt-play]').forEach(function (btn) {
      var media = btn.closest('[data-cpt-media]');
      var video = media && media.querySelector('[data-cpt-video]');
      if (!video) return;
      video.removeAttribute('controls');
      btn.addEventListener('click', function () {
        video.controls = true;
        media.classList.add('is-playing');
        var p = video.play();
        if (p && p.catch) { p.catch(function () {}); }
      });
      video.addEventListener('pause', function () { if (video.currentTime === 0) { media.classList.remove('is-playing'); } });
    });

    var bar = root.querySelector('[data-cpt-bar]');
    var tabs = bar ? Array.prototype.slice.call(bar.querySelectorAll('[role="tab"]')) : [];
    var panels = Array.prototype.slice.call(root.querySelectorAll('.cpt-panel'));
    if (!panels.length) return;
    var hasTabs = tabs.length > 1 && tabs.length === panels.length;
    var accs = panels.map(function (p) { return p.querySelector('[data-cpt-acc]'); });
    var mqDesk = window.matchMedia('(min-width: 64rem)');
    var active = 0;

    function reveal(tab) {
      if (!bar || !tab) return;
      var r = tab.getBoundingClientRect(), br = bar.getBoundingClientRect();
      if (r.left < br.left) { bar.scrollBy({ left: r.left - br.left - 16, behavior: 'smooth' }); }
      else if (r.right > br.right) { bar.scrollBy({ left: r.right - br.right + 16, behavior: 'smooth' }); }
    }

    /* Chrome ne declenche pas toujours le chargement paresseux d'une image dont le volet
       vient d'etre affiche : on force le chargement du volet ouvert. */
    function wake(p) {
      p.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    }

    function apply() {
      var desk = mqDesk.matches;
      if (desk && active < 0) { active = 0; }
      tabs.forEach(function (t, j) {
        var on = j === active;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, j) {
        var on = j === active;
        var tabsMode = hasTabs && desk;
        var open = hasTabs ? (desk || on) : true;
        p.hidden = tabsMode ? !on : false;
        if (accs[j]) { accs[j].setAttribute('aria-expanded', open ? 'true' : 'false'); }
        var inner = p.querySelector('[data-cpt-inner]');
        if (tabsMode) {
          p.setAttribute('role', 'tabpanel');
          p.setAttribute('tabindex', '0');
          if (tabs[j]) { p.setAttribute('aria-labelledby', tabs[j].id); }
          if (inner) { inner.removeAttribute('role'); inner.removeAttribute('aria-labelledby'); }
        } else {
          p.removeAttribute('role');
          p.removeAttribute('aria-labelledby');
          p.removeAttribute('tabindex');
          if (inner && accs[j]) { inner.setAttribute('role', 'region'); inner.setAttribute('aria-labelledby', accs[j].id); }
        }
        if (open) { wake(p); }
        if (!on) {
          var v = p.querySelector('[data-cpt-video]');
          if (v && !v.paused) { v.pause(); }
        }
      });
    }

    function select(i, moveFocus) {
      active = i;
      apply();
      if (moveFocus && i >= 0 && tabs[i]) { tabs[i].focus(); }
      if (i >= 0 && tabs[i]) { reveal(tabs[i]); }
    }

    apply();

    tabs.forEach(function (t, i) { t.addEventListener('click', function () { select(i, false); }); });
    accs.forEach(function (a, i) {
      if (!a) return;
      a.addEventListener('click', function () { select(active === i && !mqDesk.matches ? -1 : i, false); });
    });
    if (mqDesk.addEventListener) { mqDesk.addEventListener('change', apply); } else if (mqDesk.addListener) { mqDesk.addListener(apply); }

    if (bar) {
      bar.addEventListener('keydown', function (e) {
        var cur = tabs.indexOf(document.activeElement);
        if (cur < 0) return;
        var next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = (cur + 1) % tabs.length; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = (cur - 1 + tabs.length) % tabs.length; }
        else if (e.key === 'Home') { next = 0; }
        else if (e.key === 'End') { next = tabs.length - 1; }
        if (next < 0) return;
        e.preventDefault();
        select(next, true);
      });
    }

    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest ? e.target.closest('.cpt-panel') : null;
      if (!panel || !root.contains(panel)) return;
      var i = panels.indexOf(panel);
      if (i >= 0) { select(i, false); }
    });
  }

  function boot() { document.querySelectorAll('.cpt[data-cpt]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
